import React from "react";
import styles from "./index.module.scss";
import { convertDateTime } from "../../Helpers/date";
import ModalImage from "react-modal-image";
import defaultSignature from "../../Assets/images/default-signature.svg";
import { useOrderAttributeProvider } from "../../Pages/Order/Order/context/order";
import { useFormikContext } from "formik";
import Select from "Components/FormControl/Select/NewSelect";
import {ORDER_STATUS_FILTER} from "../../Helpers/Constants";

const OrderSummery = (props) => {
  const { module, orderDetail } = useOrderAttributeProvider();
  const formik = useFormikContext();
  //Check if the order is a Burq order or not
  const isBurqOrder = orderDetail && orderDetail.is_burq_order ? true : false;
  return (
    <div>
      {isBurqOrder && 
        <div className={`${styles.burqOrderWarning} mt-5`}>
          If this order requires Burq to be updated, you must do so manually; Burq does not support automatic updates at this time
        </div>
      }
      <h3 className={`${isBurqOrder ? "mt-4" : "mt-5"} bold`}>Order</h3>
      <div className={`row ${styles.OrderSummeryCard}`}>
        <div
          className={`${styles.OrderSummeryItem} col-12 col-lg-2 col-md-3 col-sm-12 col-xs-12`}
        >
          <div className={`${styles.OrderSummeryLabel}`}>Order Number</div>
          <div className={`${styles.OrderSummeryDetail}`}>
            {props.orderNumber}
          </div>
        </div>
        <div
          className={`${styles.OrderSummeryItem} col-12 col-lg-3 col-md-3 col-sm-12 col-xs-12`}
        >
          <div className={`${styles.OrderSummeryLabel}`}>Order Date</div>
          <div className={`${styles.OrderSummeryDetail}`}>
            {props.orderDate && props.orderDate !== null ? convertDateTime(props.orderDate, 'iso', "ccc LLL dd, yyyy, hh:mm a", "", module == "edit-order" ? formik?.values?.orderTimezone : "") : "-"}
          
          </div>
        </div>
        <div
          className={`${styles.OrderSummeryItem} col-12 col-lg-3 col-md-3 col-sm-12 col-xs-12`}
        >
          <div className={`${styles.OrderSummeryLabel}`}>Delivery Date</div>
          <div className={`${styles.OrderSummeryDetail}`}>
            {props.deliveryDate && props.deliveryDate !== null ? convertDateTime(props.deliveryDate, 'iso', "ccc LLL dd, yyyy", "", module == "edit-order" ? formik?.values?.orderTimezone : "") : "-"}
            {props.deliveryDate && props.deliveryDate !== null ? " "+props.delivery_time : "-"}
          </div>
        </div>
        <div
          className={`${styles.OrderSummeryItem} col-12 col-lg-2 col-md-3 col-sm-12 col-xs-12`}
        >
          <div className={`${styles.OrderSummeryLabel}`}>Delivery Status</div>
          <div className={`${styles.OrderSummeryDetail}`}>
            {props.module === "edit-order" ? (
              <Select
                  label=""
                  value={formik.values.order_status}
                  required={true}
                  disabled={false}
                  onChange={(data) => {
                    formik.setFieldValue('order_status', data['id'])
                  }}
                  options={ORDER_STATUS_FILTER.slice(1)}  // slice out the "ALL" option
              />
            ) : (
              props.deliveryStatus
            )}
          </div>
        </div>
        <div
          className={`${styles.OrderSummeryItem} col-12 col-lg-2 col-md-3 col-sm-12 col-xs-12`}
        >
          <div className={`${styles.OrderSummeryLabel}`}>Time Delivered</div>
          <div className={`${styles.OrderSummeryDetail}`}>
            {props.timeDelivered && props.timeDelivered !== null ? convertDateTime(props.timeDelivered, 'iso', "hh:mm a", "", module == "edit-order" ? formik?.values?.orderTimezone : "") : "-"} 
          </div>
        </div>
        <div
          className={`${styles.OrderSummeryItem} col-12 col-lg-2 col-md-3 col-sm-12 col-xs-12 mt-3`}
        >
          <div className={`${styles.OrderSummeryLabel}`}>Order Taken By</div>
          <div className={`${styles.OrderSummeryDetail}`}>{props.takenBy}</div>
        </div>
        <div
          className={`${styles.OrderSummeryItem} col-12 col-lg-3 col-md-3 col-sm-12 col-xs-12 mt-3`}
        >
          <div className={`${styles.OrderSummeryLabel}`}>Designed By</div>
          <div className={`${styles.OrderSummeryDetail}`}>
            {props.designedBy}
          </div>          
        </div>
        <div className={`${styles.OrderSummeryItem} col-12 col-lg-3 col-md-3 col-sm-12 col-xs-12 mt-3`}>
          <div className={`${styles.OrderSummeryLabel}`}>Driver Name</div>
          <div className={`${styles.OrderSummeryDetail}`}>
            {props.driverName }
            {props.onfleetTaskId && !props.isBurqOrder && (
              <span style={{ marginLeft: '10px' }}>
                <a
                  href={`https://app.onfleet.com/dashboard#/table?taskEdit=false&open=task&taskId=${props.onfleetTaskId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: 'none', color: '#1976d2' }}
                >
                  (View in Onfleet)
                </a>
              </span>
            )}
          </div>
        </div>
        <div
          className={`${styles.OrderSummeryItem} col-12 col-lg-2 col-md-3 col-sm-12 col-xs-12 mt-3`}
        >
          <div className={`${styles.OrderSummeryLabel}`}>Source</div>
          <div className={`${styles.OrderSummeryDetail}`}>{props.source}</div>
        </div>
        <div
          className={`${styles.OrderSummeryItem} col-12 col-lg-2 col-md-3 col-sm-12 col-xs-12 mt-3`}
        >
          <div className={`${styles.OrderSummeryLabel}`}>Store Delivering</div>
          <div className={`${styles.OrderSummeryDetail}`}>
            {props?.deliveringStore?.title}
          </div>
        </div>
        <div className={`${styles.OrderSummeryItem} ${styles.OrderSummerySignatureItem} col-12 col-lg-3 col-md-6 col-sm-12 col-xs-12 mt-3`}
        >
          <div className={`${styles.OrderSummeryDetail}`}>
            <img
              src={props.signature}
              alt="signature"
              style={{ width: "100px", height: "85px" }}
            />
          </div>
          <div className={`${styles.OrderSummeryLabel}`}>
            Recipient signature or Picture from driver
          </div>
        </div>
        <div
          className={`${styles.OrderSummeryItem} ${styles.OrderSummerySignatureItem} col-12 col-lg-3 col-md-6 col-sm-12 col-xs-12 mt-3`}
        >
          {/* {props?.orderCompletedImages?.length > 0 ?
            props?.orderCompletedImages.map((orderImages) => (
              <>
                <div className={`${styles.OrderSummeryDetail}`} style={{ maxWidth: "100px", maxHeight: "85px" }}>
                  <ModalImage
                    small={orderImages.image ?? ""}
                    large={orderImages.image ?? ""}
                  />
                </div>
              </>
            ))
            : (
              <><div className={`${styles.OrderSummeryDetail}`}>
                <img
                  src={defaultSignature}
                  alt="designed images"
                  style={{ width: "100px", height: "85px" }}
                />
              </div></>
            )
          } */}
          {props?.orderCompletedImages?.length > 0 ?
              <>
              <div className={`${styles.OrderSummeryDetail}`} style={{ maxWidth: "100px", maxHeight: "85px" }}>
                <ModalImage
                  className={`${styles.modalImageWrapper}`}
                  small={props?.orderCompletedImages[0].image ?? ""}
                  large={props?.orderCompletedImages[0].image ?? ""}
                />
              </div>
            </>
            : (
              <><div className={`${styles.OrderSummeryDetail}`}>
                <img
                  src={defaultSignature}
                  alt="designed images"
                  style={{ width: "100px", height: "85px" }}
                />
              </div></>
            )
          }
          <div className={`${styles.OrderSummeryLabel}`}>
            Arrangement designed image
          </div>
        </div>
      </div>
    </div>

  );
};

export default OrderSummery;
